import { Button } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { useNavigate } from "react-router-dom";
import { DashLayout } from "../../../Components/DashLayout";

const NotFoundState = () => {
  const navigate = useNavigate();

  return (
    <DashLayout title="Not Found">
      <div className="rounded-lg bg-white p-6 shadow-sm shadow-black/25">
        <p>Tournament or competition not found.</p>
        <Button onClick={() => navigate("/")} className="mt-4">
          Return to Home
        </Button>
      </div>
    </DashLayout>
  );
};

export default ApplicationView(NotFoundState);
